module.exports = require("@swa-ui/placements/src/ListPlacements/ListPlacements.module.scss");